import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LL_H_C, LL_V_L, TS_PropRenderer } from '@nu-art/thunderstorm-frontend';
import './Editor_AIPrompt.scss';
import { DropDown_AIPromptType } from '../../_enum/ai-prompt-type/ui-components.js';
import { TS_TextAreaV2 } from '@nu-art/thunderstorm-frontend/components/TS_V2_TextArea/TS_TextAreaV2';
import { TS_InputV2 } from '@nu-art/thunderstorm-frontend/components/TS_V2_Input/TS_InputV2';
const Input = TS_InputV2.editable({
    type: 'text',
    trim: true,
    saveEvent: ['blur'],
});
const TextArea = TS_TextAreaV2.editable({
    saveEvent: ['blur'],
    resizeWithText: true, // Auto-resize with content
    trim: true
});
const Render_Label = (p) => {
    return _jsx(TS_PropRenderer.Horizontal, { label: 'Label', children: _jsx(Input, { editable: p.editable, prop: 'label', disabled: !p.editMode }) });
};
const Render_Type = (p) => {
    return _jsx(TS_PropRenderer.Horizontal, { label: 'Type', children: _jsx(DropDown_AIPromptType.editable, { editable: p.editable, prop: 'type', disabled: !p.editMode }) });
};
const Render_Content = (p) => {
    return _jsx(TS_PropRenderer.Vertical, { label: 'Content', children: _jsx(TextArea, { editable: p.editable, prop: 'content', disabled: !p.editMode }) });
};
export const Editor_AIPrompt = (p) => {
    return _jsxs(LL_V_L, { className: 'e__ai-prompt', children: [_jsxs(LL_H_C, { className: 'e__row', children: [_jsx(Render_Label, { ...p }), _jsx(Render_Type, { ...p })] }), _jsx(LL_H_C, { className: 'e__row', children: _jsx(Render_Content, { ...p }) })] });
};
//# sourceMappingURL=Editor_AIPrompt.js.map